<template>
  <!-- 栅格垂直布局方式
       @author: 王汝鹏
       @date: 2019-9-13
   -->
  <div class="setting-item">
    <el-form-item label="垂直排列方式"> 
      <el-select class="setting-grid-align" v-model="align">
        <el-option value="top" label="顶部对齐"></el-option>
        <el-option value="middle" label="居中"></el-option>
        <el-option value="bottom" label="底部对齐"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 基础属性-栅格垂直排列方式
     *  @description 将 align 字段映射到当前 align 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      align: { 
        parent: i => i.baseOption,
        attr: "align" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingGridAlign.vue